<template>
  <div>
    <!-- <InputContainer
      ref="createBookingInfo"
      :configs="createBookingConfig"
    >
    </InputContainer> -->
    <div
      class="mb-3"
    >
      <UniversalInput
        v-model="bookingInfo.courseDate"
        :config="courseDateConfig"
        @input="handleCourseDateInput"
      ></UniversalInput>
    </div>
    <section>
      <h3 class="font-weight-bold">
        Student:
      </h3>
      <user-list
        ref="selectStudentList"
        :enable-search="true"
        :user-list="studentList"
        @click="handleClick"
        @remove="handleRemove"
      ></user-list>
    </section>
    <section>
      <h3 class="font-weight-bold">
        Course:
      </h3>
      <vue-horizontal
        v-show="orderList.length>0"
        ref="horizontal"
        scroll
        :button="false"
        class="horizontal mb-5"
      >
        <section
          v-for="(orderData, index) in orderList"
          :key="orderData.id"
        >
          <OrderItem
            :order-data="orderData"
            :selected="orderData.selected"
            @click="handleOrderClick"
            @remove="handleOrderRemove"
          ></OrderItem>
        </section>
      </vue-horizontal>
    </section>
    <v-row
      v-if="showStartTime"
      class="mb-3"
    >
      <v-col>
        <div>{{ courseStartTimeConfig.label || courseStartTimeConfig.toplabel }}</div>
        <UniversalInput
          v-model="bookingInfo.courseStartTime"
          :config="courseStartTimeConfig"
          @input="handleCourseStartTimeInput"
        ></UniversalInput>
      </v-col>
      <v-col>
        <div>Course End Time (Calculated)</div>
        <v-text-field
          v-model="courseEndTime"
          outlined
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <section v-if="tab=='center'">
      <h3 class="font-weight-bold">
        Coach:
      </h3>
      <user-list
        ref="selectCoachList"
        :enable-search="true"
        :user-list="coachList"
        @click="handleCoachClick"
        @remove="handleRemove"
      ></user-list>
    </section>
  </div>
</template>
<script setup>
import { ref, nextTick, onMounted, toRefs, computed, watch } from 'vue'
import VueHorizontal from 'vue-horizontal'
import moment from '@/utils/moment'
import UserList from '@/components/UserSelector/UserList'
import InputContainer from '@/components/CRUD/InputContainer'
import UniversalInput from '@/components/CRUD/UniversalInput'
import { useStore } from '@/store'
import { ListStudent, listInsiteCoach } from '@/api/bookedCourse'
import OrderItem from './components/OrderItem'
import { loading } from '@/utils/helper'

const bookingInfo = ref({
  courseDate: null,
  courseStartTime: null,
})

const showStartTime = ref(false)

const props = defineProps({
  selectedDay: {
    type: String,
    default: '',
  },
  createBookingDialog: {
    type: Boolean,
    default: false,
  },
  centerID: {
    type: Number,
    default: -1,
  },
  tab: {
    type: String,
    default: 'coach',
  },
})
const { selectedDay, createBookingDialog, centerID, tab } = toRefs(props)

const orderDataRef = ref(null)
const courseEndTime = computed(() => {
  if (bookingInfo.value.courseStartTime) {
    let duration = 60

    // console.log('orderDataRef.value', orderDataRef)
    if (orderDataRef.value && orderDataRef.value.course && orderDataRef.value.course.duration) {
      duration = orderDataRef.value.course.duration
    }
    const endTime = moment(bookingInfo.value.courseStartTime).add(duration, 'minutes').format('HH:mm')
    console.log('end time ', endTime)

    return endTime
  }

  return ''
})
const courseStartTimeConfig = ref({
  propName: 'courseStartTime',
  toplabel: 'Select Course Start Date',
  type: {
    name: 'timepicker',
  },
})

const orderList = ref([])

// function get default start time which is one hour after current time if current time is after 12 pm
function getDefaultStartTime(dateValue) {
  let defaultDate = moment(dateValue).startOf('day').add('12:00')
  const now = moment()

  // console.log('defaultDate', defaultDate)
  // console.log('now', now)
  // console.log('now.isAfter(defaultDate)', now.isAfter(defaultDate))

  if (now.isAfter(defaultDate)) {
    // now add 1 hour
    defaultDate = moment(dateValue).startOf('day').add(now.add(1, 'hour').format('HH:00'))
  }

  return defaultDate.format('yyyy-MM-DD HH:mm:ss')
}
function handleCourseDateInput(dateValue) {
  console.log('dateValue', dateValue)
  bookingInfo.value.courseStartTime = getDefaultStartTime(dateValue)
  console.log('bookingInfo.value.courseStartTime', bookingInfo.value.courseStartTime)
}
function handleOrderRemove() {
  console.log('handleOrderRemove')
  for (let i = 0; i < orderList.value.length; i += 1) {
    orderList.value[i].selected = false
  }
  orderDataRef.value = null
  bookingInfo.value.courseID = null
  bookingInfo.value.centerID = null
  bookingInfo.value.salesOrderID = null
  showStartTime.value = false
  console.log('bookingInfo', bookingInfo.value)
}
function handleOrderClick(orderData) {
  for (let i = 0; i < orderList.value.length; i += 1) {
    orderList.value[i].selected = false
    if (orderList.value[i].id === orderData.id) {
      orderList.value[i].selected = true
    }
  }
  console.log('handleOrderClick', orderData)
  orderDataRef.value = orderData
  console.log('orderDataRef', orderDataRef)
  bookingInfo.value.courseID = orderData.courseID
  bookingInfo.value.centerID = orderData.centerID
  bookingInfo.value.salesOrderID = orderData.id
  showStartTime.value = true
  console.log('bookingInfo', bookingInfo.value)
}

function handleRemove(item) {
  console.log('handleRemove', item)
  orderDataRef.value = null
  bookingInfo.value.userRecordID = null
  bookingInfo.value.assignedCoachID = null
  bookingInfo.value.courseID = null
  bookingInfo.value.centerID = null
  bookingInfo.value.courseDate = selectedDay.value

  // bookingInfo.value.courseStartTime = moment(selectedDay.value).startOf('day').add('12:00').format('yyyy-MM-DD HH:mm:ss')
  bookingInfo.value.courseStartTime = getDefaultStartTime(selectedDay.value)
  bookingInfo.value.salesOrderID = null
  showStartTime.value = false
  orderList.value = []
}
const studentList = ref([])
const coachList = ref([])
const selectStudentList = ref(null)
const selectCoachList = ref([])
function reset() {
  orderDataRef.value = null
  bookingInfo.value.userRecordID = null
  bookingInfo.value.assignedCoachID = null
  bookingInfo.value.courseID = null
  bookingInfo.value.centerID = null
  bookingInfo.value.salesOrderID = null

  bookingInfo.value.courseDate = selectedDay.value

  // bookingInfo.value.courseStartTime = moment(selectedDay.value).startOf('day').add('12:00').format('yyyy-MM-DD HH:mm:ss')
  bookingInfo.value.courseStartTime = getDefaultStartTime(selectedDay.value)
  showStartTime.value = false
  orderList.value = []

  selectStudentList.value.internalList = [...studentList.value]
  selectStudentList.value.selectedList = []

  if (selectCoachList.value) {
    selectCoachList.value.internalList = [...coachList.value]
    selectCoachList.value.selectedList = []
  }

  // courseStartTime.value = moment(selectedDay.value).startOf('day').add('12:00').format('yyyy-MM-DD HH:mm:ss')
  // bookingInfo.value.courseStartTime = moment(selectedDay.value).startOf('day').add('12:00').format('yyyy-MM-DD HH:mm:ss')
}

function handleCoachClick(item) {
  bookingInfo.value.assignedCoachID = item.id
}

function handleClick(item) {
  console.log('handleClick', item)

  if (item.salesOrders) {
    orderList.value = []
    for (let index = 0; index < item.salesOrders.length; index += 1) {
      const orderItem = item.salesOrders[index]
      orderItem.selected = false
      orderList.value.push(orderItem)
    }
  }

  bookingInfo.value.userRecordID = item.id
}

const courseDateConfig = ref({
  propName: 'courseDate',
  toplabel: 'Select Course Date',
  type: {
    name: 'datepicker',
  },
})
defineExpose({ bookingInfo, reset })

onMounted(() => {
  loading(true)
  if (selectedDay.value) {
    bookingInfo.value.courseDate = selectedDay.value

    // bookingInfo.value.courseStartTime = moment(selectedDay.value).startOf('day').add('12:00').format('yyyy-MM-DD HH:mm:ss')
    bookingInfo.value.courseStartTime = getDefaultStartTime(selectedDay.value)
  }
  ListStudent()
    .then(result => {
      studentList.value.length = 0
      const students = result.data.items
      studentList.value.push(...students)
    })
    .catch(err => {
      console.log('err', err)
    }).finally(() => {
      loading(false)
    })
  console.log('bookingInfo.value', bookingInfo.value)
  if (tab.value === 'center') {
    listInsiteCoach(bookingInfo.value)
      .then(result => {
        coachList.value.length = 0
        const coachs = result.data.items
        coachList.value.push(...coachs)
      })
      .catch(err => {
        console.log('err', err)
      }).finally(() => {
        loading(false)
      })
  }
})
watch(centerID, newValue => {
  console.log('centerID updated', newValue)

  nextTick(() => {
    if (tab.value === 'center') {
      listInsiteCoach(bookingInfo.value)
        .then(result => {
          coachList.value.length = 0
          const coachs = result.data.items
          coachList.value.push(...coachs)
        })
        .catch(err => {
          console.log('err', err)
        }).finally(() => {
          loading(false)
        })
    }
  })
})
watch(selectedDay, newValue => {
  console.log('selectedDay updated', newValue)

  nextTick(() => {
    bookingInfo.value.courseDate = newValue

    // bookingInfo.value.courseStartTime = moment(selectedDay.value).startOf('day').add('12:00').format('yyyy-MM-DD HH:mm:ss')
    bookingInfo.value.courseStartTime = getDefaultStartTime(newValue)
  })
})
watch(createBookingDialog, newValue => {
  console.log('createBookingDialog updated', newValue)
  if (newValue) {
    loading(true)
    ListStudent()
      .then(result => {
        studentList.value.length = 0
        const students = result.data.items
        studentList.value.push(...students)
      })
      .catch(err => {
        console.log('err', err)
      }).finally(() => {
        loading(false)
      })
  }
})

function handleCourseStartTimeInput(value) {
  // console.log('bookingInfo.value', bookingInfo.value)
  if (tab.value === 'center') {
    loading(true)
    listInsiteCoach(bookingInfo.value)
      .then(result => {
        coachList.value.length = 0
        const coachs = result.data.items
        coachList.value.push(...coachs)
      })
      .catch(err => {
        console.log('err', err)
      }).finally(() => {
        loading(false)
      })
  }

  // bookingInfo.value.courseStartTime = value
}
</script>
<style scoped>

.horizontal >>> .v-hl-container {
  /* Space between content and scrollbar */
  /* padding-bottom: 16px; */

  /* For firefox only */
  scrollbar-width: thin;
  /* scrollbar-color: orangered black; */
}

.horizontal >>> .v-hl-container::-webkit-scrollbar {
  height: 0px;
  width: 16px;
  background: transparent;
}

.horizontal >>> .v-hl-container::-webkit-scrollbar-track {
  /* background: black; */
  border-radius: 4px;
  background: #e6e6e6;
  border-left: 1px solid #dadada;
}

.horizontal >>> .v-hl-container::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #b0b0b0;
  border: solid 3px #e6e6e6;
}

</style>
